import React, { useEffect, useLayoutEffect } from 'react';
import { CenteredWrapper, Container, TopRow } from '../../../pages/styles';
import { Form as StyledForm } from '../../../pages/Auth/styles';
import { Url } from 'finhelper';
import { useAppDispatch } from '#app/hooks/useAppStore';
import { handleTitle } from '../../../actions/interface';
import { handleLoginModal } from '../../../actions/auth';

const Forbidden = () => {
  const dispatch = useAppDispatch();

  useLayoutEffect(() => {
    dispatch(handleLoginModal());
  }, [dispatch]);

  useEffect(() => {
    dispatch(handleTitle('Требуется авторизация'));
  }, [dispatch]);

  const submitForm = (e) => {
    e.preventDefault();
    // Здесь логика отправки формы
  };

  const url = Url.getCurrentUrl();

  return (
    <Container
      style={{
        margin: url.indexOf('/cabinet') !== -1 ? '0 auto' : '20px auto 0 auto',
      }}
    >
      <CenteredWrapper>
        <StyledForm
          style={{
            maxWidth: '440px',
            margin: '0 auto',
          }}
          action="#"
          onSubmit={submitForm}
        >
          <TopRow flex></TopRow>
        </StyledForm>
      </CenteredWrapper>
    </Container>
  );
};

export default Forbidden;
